import { swiperDefaults } from '../globals.js'

import Swiper, { A11y, Navigation } from 'swiper'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/**
 * Best Use Mobile Slider
 */
const mediaQuery = window.matchMedia('(max-width:64em)')
let swiperInstance = false

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        if (document.querySelector('[data-filters-slider]')) {
            swiperInstance = new Swiper('[data-filters-slider]', {
                ...swiperDefaults,
                slidesPerView: 'auto',
                spaceBetween: 15,
                slidesPerGroup: 2,
                modules: [Navigation, A11y]
            })
            return
        }
    }

    if (swiperInstance) swiperInstance.destroy(true, true)
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)

/**
 * Sticky Sidebar
 */
const sidebar = document.querySelector('[data-sticky-sidebar]')

const sidebarWillFit = () => {
    return window.innerHeight >= (sidebar.getBoundingClientRect().height + 120)
}

if (sidebar && sidebarWillFit()) {
    sidebar.classList.add('isSticky')
}
